<script setup lang="ts">
const router = useRouter();
const user = useDirectusUser();
const { logout } = useDirectusAuth();

const logoutAndRedirect = async () => {
  await logout();
  router.push("/");
};

const items = computed(() => [
  [
    {
      label: user.value?.email,
      slot: "account",
      disabled: true,
    },
  ],
  [
    {
      label: "Playlists",
      to: "/playlist",
      // disabled: true,
      icon: "i-heroicons-folder",
    },
    {
      label: "Paramètres",
      to: "/settings",
      // disabled: true,
      icon: "i-heroicons-cog-8-tooth",
    },
  ],
  [
    {
      label: "Déconnexion",
      icon: "i-heroicons-arrow-left-on-rectangle",
      click: logoutAndRedirect,
    },
  ],
]);
</script>

<template>
  <UDropdown v-slot="{ open }" :items="items">
    <!-- <UButton
      color="gray"
      variant="ghost"
      :class="[open && 'bg-gray-50 dark:bg-gray-800']"
      class="w-full"
    > -->
    <!-- <UAvatar icon="i-material-symbols-person" /> -->
    <!-- <UAvatar src="https://avatars.githubusercontent.com/u/739984?v=4" /> -->
    <UAvatar :alt="user.email" class="select-none" />
  </UDropdown>
</template>
